import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SunIcon } from '../../../components/ui/Icons';
import { useUnreadReleaseCount } from '../../WhatsNew/unreadStore';
import styles from './WhatsNewButton.module.css';

interface WhatsNewButtonProps {
  /** La forma la pone el dashboard: es la misma pastilla de *Refresh*, para que se lean como un par. */
  className?: string;
}

/**
 * *WHAT'S NEW*, JUNTO A *REFRESH* EN EL ENCABEZADO DEL DASHBOARD (20-oct-2026).
 *
 * > *"en el dashboard, junto al boton de refresh me gustaria agregar un boton extra con el whats news junto a algun
 * > indicador si ya lo vieron"*
 *
 * - **Con algo sin ver:** el número, en el naranja que marca lo nuevo en *What's new* (la etiqueta *New*, el punto que
 *   late).
 * - **Con todo visto:** el botón solo; al pasar el cursor dice que no hay nada nuevo.
 *
 * 🔑 Es el mismo número que el globo del menú de la cuenta (`unreadStore`): abrir la pantalla marca como leído, y los
 * dos se apagan juntos.
 *
 * ⚠️ El número va también en el nombre del botón: un globo de color no le dice nada a un lector de pantalla.
 */
const WhatsNewButton: React.FC<WhatsNewButtonProps> = ({ className }) => {
  const navigate = useNavigate();
  const unread = useUnreadReleaseCount();
  const pending = `${unread} ${unread === 1 ? 'update' : 'updates'} you haven\u2019t seen`;

  return (
    <button
      type="button"
      className={className}
      onClick={() => navigate('/whats-new')}
      aria-label={unread > 0 ? `What\u2019s new, ${pending}` : 'What\u2019s new, you\u2019re all caught up'}
      title={unread > 0 ? pending : 'You\u2019re all caught up'}
    >
      <SunIcon size={16} aria-hidden="true" />
      What&rsquo;s new
      {unread > 0 && (
        <span className={styles.badge} aria-hidden="true">
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  );
};

export default WhatsNewButton;
